export const PageColumn = ({ children }) => {
  return <div className="column-clearfix">{children}</div>;
};
